export default "__VITE_ASSET__v2FcWUJ6__"